<!-- <p>main works!</p> -->

<div class="content">
    <router-outlet>
    </router-outlet>
</div>